module.exports = __webpack_public_path__ + "static/slide-1-43395b538adaa0156587de75fd942547.jpg";